<template>
  <div class="ad-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="出场名单二维码"
      left-text="返回"
      left-arrow
      @click-left="onTopClickLeft"
      class="custom-navbar"
    >
      <template #right>
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          class="home-link"
        >
          <van-icon name="wap-home" size="20" />
        </a>
      </template>
    </van-nav-bar>

    <loading-com v-if="loading" />

    <!-- 二维码列表 -->
    <div v-else class="qrcode-container">
      <div
        v-for="(item, index) in resultList"
        :key="index"
        class="qrcode-card"
      >
        <div class="card-header">
          <div class="unit-info">
            <span class="event-name" v-if="item.SSMC">{{ item.SSMC }}</span>
            <h3 class="unit-name">
              {{ item.DWQC }}
              <span v-if="item.DWJC && item.DWJC !== item.DWQC" class="unit-short">({{ item.DWJC }})</span>
            </h3>
            <div class="info-row">
              <span class="event-type">{{ item.XMJC }}</span>
            </div>
          </div>
          <span :class="getTagClass(item.SSLXMC)">{{ item.SSLXMC }}</span>
        </div>

        <div class="qrcode-wrapper">
          <img :src="item.IMGBASE" alt="二维码" class="qrcode-image" />
        </div>

        <div class="card-footer">
          <div class="jump-link" @click="handleCardClick(item.URL)">
            <span class="link-text">跳转至出场名单填写界面</span>
            <van-icon name="arrow" class="arrow-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "CcmdCodeIndex",

  data() {
    return {
      utilPost: "",
      ssid: "",
      op: "wapGL",
      resultList: [],
      loading: true
    };
  },

  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },

  mounted() {
    this.getCcmdTwoCode();
  },

  methods: {
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    },
    handleCardClick(url) {
      if (url) {
        window.location.href = url;
      }
    },
    getTagClass(sslxmc) {
      if (!sslxmc) return "tag";
      if (sslxmc.includes("男")) return "tag tag-male";
      if (sslxmc.includes("女")) return "tag tag-female";
      if (sslxmc.includes("混")) return "tag tag-mixed";
      return "tag";
    },
    getCcmdTwoCode() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称1
          methodName: "getCcmdTwoCode" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.loading = false;
        if (!data.isSuccess) {
          alert(data.msg);
        }
        this.resultList = data.content || [];
      });
    }
  }
};
</script>

<style scoped>
.ad-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.custom-navbar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.home-link {
  color: #1989fa;
  text-decoration: none;
}

.qrcode-container {
  padding: 16px;
}

.qrcode-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 16px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
}

.qrcode-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.unit-info {
  flex: 1;
}

.event-name {
  display: inline-block;
  font-size: 13px;
  color: #1989fa;
  background: #e6f7ff;
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 500;
  margin-bottom: 8px;
}

.unit-name {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.unit-short {
  font-size: 14px;
  font-weight: 400;
  color: #999;
}

.info-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.event-type {
  display: inline-block;
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 4px;
}

.tag {
  display: inline-block;
  padding: 6px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.tag-male {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.tag-female {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.tag-mixed {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.qrcode-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 12px;
}

.qrcode-image {
  width: 100%;
  max-width: 280px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
  margin-top: 8px;
  border-top: 1px dashed #e8e8e8;
}

.jump-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
}

.jump-link:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  transform: scale(1.05);
}

.jump-link:active {
  transform: scale(0.98);
}

.link-text {
  white-space: nowrap;
}

.arrow-icon {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.jump-link:hover .arrow-icon {
  transform: translateX(4px);
}
</style>



// WEBPACK FOOTER //
// src/components/CcmdCodeIndex/CcmdCodeIndex.vue